import React, { useEffect } from "react";

import debounce from "lodash.debounce";

import {
  StyledEditableTextarea,
  StyledTextareaCalculator,
} from "../../../../../../../../components/inline-edit/styled";
import { useCardsStore } from "../../../../../../../../stores/use-cards-store";

function EditableText({
  data,
  config,
  inputProp = "",
  customStyles = {},
  customCalculatorStyles = {},
  disableNewLine = false,
}) {
  const { updateCardData, selectedCard, setCard } = useCardsStore((state) => ({
    updateCardData: state.updateCardData,
    selectedCard: state.card,
    setCard: state.setCard,
  }));

  const textareaRef = React.useRef();
  const textareaHelperRef = React.useRef();

  useEffect(() => {
    if (!data.id) return;
    const resizeObserver = new ResizeObserver(
      debounce((entries) => {
        const entry = entries[0];
        const helperHeight = entry.contentRect.height;
        if (textareaRef?.current) {
          textareaRef.current.style.height = `${helperHeight}px`;
        }
      })
    );

    const element = document.getElementById(
      `${data.id}-text-area-helper-${inputProp}`
    );

    resizeObserver.observe(element);

    return () => resizeObserver.disconnect();
  }, [data.id]);

  return (
    <div style={{ position: "relative" }}>
      <StyledEditableTextarea
        ref={textareaRef}
        value={data[inputProp]}
        style={{ ...customStyles, overflow: "hidden" }}
        onInput={(e) => {
          if (disableNewLine && e.nativeEvent.inputType === "insertLineBreak") {
            return;
          }
          updateCardData({
            id: data.id,
            key: inputProp,
            value: e.target.value,
          });
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (!selectedCard || selectedCard?.card?.id !== data.id) {
            setCard({ card: data, config });
          }
        }}
      />
      <StyledTextareaCalculator
        id={`${data.id}-text-area-helper-${inputProp}`}
        ref={textareaHelperRef}
        width="100%"
        style={{ ...customCalculatorStyles }}
      >
        {data[inputProp]}
      </StyledTextareaCalculator>
    </div>
  );
}

export default EditableText;
